// For gzip Decompression
const pako = require('pako');

const pakoDecompress = (compressed) => {
	return JSON.parse(pako.inflate(atob(compressed), { to: 'string' }));
};

export {
	pako,
	pakoDecompress
};